export const SIGNIN_USER_REQUEST = 'SIGNIN_USER_REQUEST';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNIN_USER_FAILURE = 'SIGNIN_USER_FAILURE';

export const GET_ALL_NOTIFICATION_REQUEST = 'GET_ALL_NOTIFICATION_REQUEST';
export const GET_ALL_NOTIFICATION_SUCCESS = 'GET_ALL_NOTIFICATION_SUCCESS';
export const GET_ALL_NOTIFICATION_FAILURE = 'GET_ALL_NOTIFICATION_FAILURE';
export const GET_MORE_NOTIFICATION_REQUEST = 'GET_MORE_NOTIFICATION_REQUEST';
export const GET_MORE_NOTIFICATION_SUCCESS = 'GET_MORE_NOTIFICATION_SUCCESS';
export const GET_MORE_NOTIFICATION_FAILURE = 'GET_MORE_NOTIFICATION_FAILURE';
export const GET_BADGE_NOTIFICATION_REQUEST = 'GET_BADGE_NOTIFICATION_REQUEST';
export const GET_BADGE_NOTIFICATION_SUCCESS = 'GET_BADGE_NOTIFICATION_SUCCESS';
export const GET_BADGE_NOTIFICATION_FAILURE = 'GET_BADGE_NOTIFICATION_FAILURE';
export const READS_NOTIFICATION_ACTION = 'READ_NOTIFICATION_ACTION';
export const READS_NOTIFICATION_REQUEST = 'READS_NOTIFICATION_REQUEST';
export const READS_NOTIFICATION_SUCCESS = 'READS_NOTIFICATION_SUCCESS';
export const READS_NOTIFICATION_FAILED = 'READS_NOTIFICATION_FAILED';

export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE';

export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';

export const CLEAR_SESI = 'CLEAR_SESI';
export const OVERRIDE_USER_ACTION = 'OVERRIDE_USER_ACTION';
